"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
(function () {
    var CookieNotice = {
        initialize: function () {
            if ($.cookie('cookie_accept') === undefined) {
                $('[data-cookie-accept]').on('click', function () {
                    $.cookie('cookie_accept', 'cookies accepted', { expires: 365, path: '/' });
                    $('[data-cookie-notice]').fadeOut();
                });
            }
            else {
                // Remove cookie notice to prevent it from beeing displayed even if notice was accepted
                $('[data-cookie-notice]').hide();
            }
        }
    };
    CookieNotice.initialize();
})();
exports.default = {};
